<template>
  <CommunityCard class="pw-change-container">
    <form class="regform">
      <div class="text-center">
        <img class="mb-5" width="260" src="../assets/iSimulate-Logo.svg" />
      </div>

      <div class="mb-4 alert alert-primary">You must change your password on first login.</div>

      <div class="form-group">
        <label for="password1">Password</label>
        <input
          type="password"
          v-model="password"
          :class="{
            'form-control': true,
            'is-invalid': !passwordValid || !passwordsMatch,
          }"
          id="password1"
        />
        <label class="mt-3" for="password2">Confirm Password</label>
        <input
          type="password"
          v-model="password2"
          :class="{
            'form-control': true,
            'is-invalid': !passwordValid || !passwordsMatch,
          }"
          class="form-control"
          id="password2"
        />
        <small id="passwordHelpBlock" class="form-text text-muted">
          Your password must be at least 8 characters long, containing at least
          one uppercase, lowercase and number.
        </small>
      </div>

      <div>
        <small class="server-error" v-if="serverError">
          There was an error.
        </small>
      </div>
      <div class="alert alert-success" v-if="resetSuccess">
        <strong>Success.</strong> Your password has been reset.
      </div>

      <button
        type="submit"
        class="btn btn-lg btn-block mt-4 mb-2 change-btn"
        @click.prevent="btnHandler()"
      >
        {{ submitting ? "..." : btnText }}
      </button>
    </form>
  </CommunityCard>
</template>

<script>
import userService from "../services/user.service";
import CommunityCard from "../components/CommunityCard";

export default {
  name: "MyPasswordChangeFirstLogin",
  components: {
    CommunityCard,
  },
  data: function() {
    return {
      password: "",
      password2: "",
      passwordValid: true,
      passwordsMatch: true,
      serverError: "",
      resetSuccess: false,
      submitting: false,
      btnText: "Change Password",
    };
  },
  computed: {
    currentDistributor() {
      return this.$store.getters.getDistributor;
    },
  },
  methods: {
    btnHandler() {
      if (this.resetSuccess) this.$router.push("/scenarios");
      else this.submit();
    },
    submit() {
      if (this.submitting) return;
      this.submitting = true;

      this.passwordValid = this.passwordsMatch = true;
      this.resetSuccess = false;

      if (!this.validate()) {
        this.submitting = false;
        return;
      }

      userService
        .updatePassword(this.password, this.currentDistributor)
        .then(() => {
          this.resetSuccess = true;
          this.btnText = "Return to Community";
        })
        .catch((err) => {
          this.resetSuccess = false;
          this.serverError = err;
        })
        .finally(() => (this.submitting = false));
    },
    validate() {
      // 8 characters, one uppercase, lowercase and number
      this.passwordValid =
        this.password.length &&
        /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?!.*\s).{8,}$/.test(
          this.password
        );
      this.passwordsMatch = this.password === this.password2;

      return this.passwordValid && this.passwordsMatch;
    },
  },
};
</script>

<style scoped>
.pw-change-container {
  max-width: 600px;
  margin: 7vh auto;
}
.regform {
  max-width: 360px;
  margin: 120px auto 60px;
}

.change-btn {
  background: var(--isim-primary);
  color: white;
}

.small-link {
  font-weight: bold;
  cursor: pointer;
}

.server-error {
  color: red;
}
</style>
